import React from 'react';
import PropTypes from 'prop-types';

import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';
import _ from 'lodash';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import RuleItem from './RuleItem';

import helpers from 'helpers';

const Types = {
    LEVEL: 'level'
};

const levelSource = {
    beginDrag(props) {
        return {
            indexLevel: props.indexLevel,
            id: props.level.id,
        }
    },
    canDrag(props) {
        return !props.disabledActions;
    },
};

const levelTarget = {

    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().indexLevel;
        const hoverIndex = props.indexLevel;

        if (dragIndex === hoverIndex) {
            return
        }

        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
        const clientOffset = monitor.getClientOffset();
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return
        }

        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return
        }

        props.moveLevel(dragIndex, hoverIndex);

        monitor.getItem().indexLevel = hoverIndex;
    },
};

class LevelItem extends React.Component {
    constructor(props) {
        super(props);

        this.addRule = this.addRule.bind(this);
        this.changeTypeNewRule = this.changeTypeNewRule.bind(this);
    }

    changeTypeNewRule(index, value) {
        const { levelList, changeLevelList } = this.props;
        levelList[index].levelType = value;
        changeLevelList(levelList);
    }

    addRule(indexLevel, type) {
        const { levelList, changeLevelList } = this.props;

        levelList[indexLevel].rulesList.push({
            typeOfRule: type,
            rule: '',
            _type: '',
            color: helpers.createHashColor(),
        });

        changeLevelList(levelList);
    }

    render() {
        const {
            isDragging,
            connectDragSource,
            connectDropTarget,
            level,
            indexLevel,
            levelList,
            changeLevelList,
            disabledActions,
        } = this.props;

        const opacity = isDragging ? 0 : 1;

        return (
            connectDragSource(
                connectDropTarget(
                <div className="paper-block" style={{ opacity }}>
                    <span className='name-block absolute small-name'>Level - {level.priority}</span>
                    <div className="row">
                        <div className="col-xs-6">
                            <SelectField
                                fullWidth
                                value={levelList[indexLevel].levelType}
                                onChange={(e, i, value) => {
                                    this.changeTypeNewRule(indexLevel, value);
                                }}
                                floatingLabelText='Type of filter'
                                disabled={disabledActions}
                            >
                                <MenuItem value='single' primaryText="Single" />
                                <MenuItem value='multi' primaryText="Multi" />
                            </SelectField>
                        </div>
                        {
                            !disabledActions
                                ?
                                <div className="col-xs-6 center-xs middle-xs" style={{ display: 'flex' }}>
                                    <div>Add rule</div>
                                    <IconButton>
                                        <ContentAddIcon
                                            onClick={() => {
                                                this.addRule(indexLevel, levelList[indexLevel].levelType);
                                            }}
                                            color='green'
                                            disabled={disabledActions}
                                        />
                                    </IconButton>
                                </div>
                                :
                                ''
                        }
                    </div>
                    {
                        levelList[indexLevel].rulesList.map((rule, indexRule) => {
                            return (<RuleItem
                                key={indexRule}
                                rule={rule}
                                indexRule={indexRule}
                                indexLevel={indexLevel}
                                levelList={levelList}
                                changeLevelList={changeLevelList}
                                disabledActions={disabledActions}
                            />)
                        })
                    }
                </div>
                ))
        )
    }
}

LevelItem.propTypes = {
    changeLevelList: PropTypes.func,
    levelList: PropTypes.array,
    level: PropTypes.object,
    indexLevel: PropTypes.number.isRequired,

    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,

    isDragging: PropTypes.bool.isRequired,

    moveLevel: PropTypes.func.isRequired,
    disabledActions: PropTypes.bool,
};

export default _.flow([
    DragSource(Types.LEVEL, levelSource, (connect, monitor) => ({
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
    })),
    DropTarget(Types.LEVEL, levelTarget, connect => ({
        connectDropTarget: connect.dropTarget(),
    }))
    ]
)(LevelItem);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Sidebar/LevelItem.jsx